import React from 'react';
import { Inbox } from 'lucide-react';

// T0 — État vide homogène (remplace les rendus ad hoc « aucune donnée »).
export const EmptyState = ({ icon: IconCmp = Inbox, title = 'Aucune donnée', message = '', className = '' }) => (
  <div className={`flex flex-col items-center justify-center text-center py-16 text-gray-400 dark:text-gray-500 ${className}`}>
    <IconCmp className="h-10 w-10 mb-3" />
    <p className="font-medium text-gray-600 dark:text-gray-300">{title}</p>
    {message && <p className="text-sm mt-1 max-w-sm">{message}</p>}
  </div>
);

export default EmptyState;
